import Nav from "../Nav";
import Carousel from "../Carousel";
import Head from "../Head";

export const Rio = () => {
  var settings = {
    dots: false,
    arrows: true,
    infinite: true,
    speed: 500,
    slidesToShow: 2,
    slidesToScroll: 1,
    initialSlide: 0,
    autoplay: true,
    autoplaySpeed: 3000,
    cssEase: "linear",
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true,
          dots: false,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 1,
          dots: false,
          arrows: false,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: false,
          arrows: false,
        },
      },
    ],
  };

  return (
    <>
      <Head title="Residencias - Ir al río" />
      <Nav titulo="Ir al río 2023" link="/residencias" />
      <section
        id="about_me"
        className="mb-5  animate__fadeInDown wow animate__animated animate__delay-0s animate__slower"
      >
        
        
        <div className="row marMob">
          <div className="col-12 col-md-3 mb-2">
          <iframe
                className=" iframe"
                src={`https://www.youtube.com/embed/RGls-ETSY4Q`}
                title="YouTube video player"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowFullscreen
              ></iframe>
          </div>
          <div className="col-12 col-md-9 ps-2 ps-md-5 pe-2 pe-md-5">
            <hr />
            <h3 className="text-center fs-6">
            Ir al río – Revelar fotografías con plantas del Delta de Tigre, Buenos Aires. Marzo 2023.

            </h3>
            <hr />
            <p>Experiencia de fotografía estenopeica de revelado sin químicos donde planteamos la realización conjunta de fotografías estenopeicas que fueron reveladas a través de fórmulas con plantas del lugar.

</p>
<p>
Buscamos enlazar la práctica fotográfica con el entorno natural y creemos necesario tomas conciencia del uso medido del agua y de todo lo que el ambiente nos brinda.
</p>
<p>Esta experiencia fue gratuita gracias a la Beca Formadores del Fondo Nacional de las Artes.</p>          </div>
</div>


<hr />
<div className="p-md-4">
<Carousel settings={settings}>
        
        <img
            src="../img/ir_al_rio/ir_al_rio (4).jpg"
            className="img-fluid"
            alt="Ir al rio"
          />
          <img
            src="../img/ir_al_rio/ir_al_rio (6).jpg"
            className="img-fluid"
            alt="Ir al rio"
          />

          
        
<img
            src="../img/ir_al_rio/ir_al_rio (10).jpg"
            className="img-fluid"
            alt="Ir al rio"
          />

<img
            src="../img/ir_al_rio/ir_al_rio (13).jpg"
            className="img-fluid"
            alt="Ir al rio"
          />

<img
            src="../img/ir_al_rio/ir_al_rio (16).jpg"
            className="img-fluid"
            alt="Ir al rio"
          />

<img
            src="../img/ir_al_rio/ir_al_rio (17).jpg"
            className="img-fluid"
            alt="Ir al rio"
          />
        <img
            src="../img/ir_al_rio/ir_al_rio (5).jpg"
            className="img-fluid"
            alt="Ir al rio"
          />
        <img
            src="../img/ir_al_rio/ir_al_rio (9).jpg"
            className="img-fluid"
            alt="Ir al rio"
          />
        <img
            src="../img/ir_al_rio/ir_al_rio (14).jpg"
            className="img-fluid"
            alt="Ir al rio"
          />
        <img
            src="../img/ir_al_rio/ir_al_rio (15).jpg"
            className="img-fluid"
            alt="Ir al rio"
          />
        <img
            src="../img/ir_al_rio/ir_al_rio (11).jpg"
            className="img-fluid"
            alt="Ir al rio"
          />
        <img
            src="../img/ir_al_rio/ir_al_rio (1).jpg"
            className="img-fluid"
            alt="Ir al rio"
          />
        <img
            src="../img/ir_al_rio/ir_al_rio (2).jpg"
            className="img-fluid"
            alt="Ir al rio"
          />
        <img
            src="../img/ir_al_rio/ir_al_rio (8).jpg"
            className="img-fluid"
            alt="Ir al rio"
          />
        <img
            src="../img/ir_al_rio/ir_al_rio (7).jpg"
            className="img-fluid"
            alt="Ir al rio"
          />
        <img
            src="../img/ir_al_rio/ir_al_rio (3).jpg"
            className="img-fluid"
            alt="Ir al rio"
          />
        


        </Carousel>
        </div>        
        
      </section>
    </>
  );
};
